import { Link, useLocalSearchParams, usePathname } from 'expo-router';
import { useController, useFormContext, useWatch } from 'react-hook-form';
import { useQuery } from 'urql';
import Box from '@/components/UI/Box';
import Item from '@/components/UI/PressableRow';
import Text from '@/components/UI/Text';
import { graphql } from '@/gql/graphql';
import Icon from '../Unistyles/Icon';
import type { EventEditFormValues } from './EventEdit.types';

const GetEventEditInputParentByParent = graphql(/* GraphQL */ `
  query GetEventEditInputParentByParent($parentId: uuid!) {
    event_by_pk(id: $parentId) {
      id
      title
    }
  }
`);
const GetEventEditInputParentByEvent = graphql(/* GraphQL */ `
  query GetEventEditInputParentByEvent($eventId: uuid!) {
    event_by_pk(id: $eventId) {
      id
      rootParentId: root_parent_id
    }
  }
`);
function EventEditInputParent() {
  const { control } = useFormContext<EventEditFormValues>();
  const {
    fieldState: { error },
  } = useController({
    name: 'parentId',
    control,
  });
  const pathname = usePathname();
  const parentId = useWatch({
    name: 'parentId',
    control,
  });
  const eventType = useWatch({
    name: 'eventType',
    control,
  });
  const { eventId = '' } = useLocalSearchParams<{
    eventId?: string;
  }>();
  const [{ data: parentData }] = useQuery({
    query: GetEventEditInputParentByParent,
    variables: {
      parentId: parentId || '',
    },
    pause: !parentId,
  });
  const [{ data: eventData }] = useQuery({
    query: GetEventEditInputParentByEvent,
    variables: {
      eventId: eventId || '',
    },
    pause: !eventId,
  });
  return (
    <Box direction="horizontal" align="center">
      {!eventId || eventId !== eventData?.event_by_pk?.rootParentId ? (
        <Link
          href={{
            pathname: `${pathname}/parent`,
            params: {
              eventType,
            },
          }}
          asChild
        >
          <Item flex spaced testID="EventEditInputParent">
            <Box direction="horizontal" space="md" align="center">
              <Icon name="trophy-outline" />
              <Box direction="vertical" flex>
                <Text flexShrink={1} numberOfLines={1}>
                  {parentId
                    ? parentData?.event_by_pk?.title
                    : 'Organization, League, or Season'}
                </Text>
                {error ? (
                  <Text variant="warning" size="xs">
                    {error.message}
                  </Text>
                ) : null}
              </Box>
            </Box>
            <Icon
              name="chevron-forward"
              size="sm"
              variant="typographySecondary"
            />
          </Item>
        </Link>
      ) : null}
    </Box>
  );
}
export default EventEditInputParent;
